export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/map-banner.01257c2a-a254d8.png";